module.exports = __webpack_public_path__ + "static/img/kxfxzl.a567b95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/kxfxzl.jpg
// module id = Uf6t
// module chunks = 0